"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyString = void 0;
function isEmptyString(str) {
    return str == null || str === "";
}
exports.isEmptyString = isEmptyString;
